import React, { useEffect } from "react"
import FlexBox from "../../schoolUiComponents/basic/Box/FlexBox"
import PopupViewer from "../../schoolUiComponents/PopupViewer"
import { Colors } from "../../baseStyles/enums/colors"
import Text from "../../schoolUiComponents/basic/Text"
import SuccessIcon from "../assets/success-icon.svg"
import PositionBox from "../../schoolUiComponents/basic/Box/PositionBox"
import Fonts from "../../baseStyles/enums/fonts"
import ForgetPasswordStyles from "./style"
import { viewedPasswordResetSuccessfulPopupEvent } from "../events"


export const SuccessPopup = ({ popupCloseCallback, referralData }: any) => {

  const styles = ForgetPasswordStyles();

  useEffect(() => {
   viewedPasswordResetSuccessfulPopupEvent({ ...referralData});
  }, [])

  return (
    <PopupViewer
      closeCallback={popupCloseCallback}
      autoClose={true}
      showCrossIcon={false}
      // @ts-ignore
      padding={styles.successPopupWrap.padding}
      autoCloseTimeout={5000}
    >
      <FlexBox column gap={36} {...styles.successPopup}>
        <FlexBox column width={156} padding={"12px 12px 32px 12px"} gap={8} borderRadius={16} relative>
          <PositionBox.absolute> <SuccessIcon /> </PositionBox.absolute>
        </FlexBox>
        <FlexBox column gap={8}>
          <Text.H2 emphasis>Password reset successful!</Text.H2>
          <Text.H4 color={"rgba(26, 26, 26, 0.50)"} fontWeight={Fonts.Weight.W400}>Redirecting to login...</Text.H4>
        </FlexBox>
      </FlexBox>


    </PopupViewer>
  )
}